export enum MAIN_TAB_STATUS {
  REWARD = 'reward',
  PARTICIPATE = 'participate',
  PROGRESS = 'progress',
  MAIN_EVENT = 'main-event',
}

export enum SUB_TAB_STATUS {
  ONLINE = 'participate-online',
  OFFLINE = 'participate-offline',
}

export enum TAB_QUERY_TYPE {
  REWARD = 'reward',
  PARTICIPATE_ONLINE = 'participate-online',
  PARTICIPATE_OFFLINE = 'participate-offline',
  PROGRESS = 'progress',
  MAIN = 'main',
}
